import React from 'react';
import { Button, ButtonLink } from './Button';
import { BrandSeal, Halo } from './Decor';
import { WHATSAPP_URL } from '../data/site';
import { SECTION_IDS, scrollToSection } from '../utils/scroll';
export function FinalCta() {
  return <section aria-labelledby="cierre-titulo" className="relative overflow-hidden bg-gradient-to-b from-lavender-50 to-cream" data-id="element-31" data-mp="19giib4uajl4h">
      <Halo className="left-1/2 top-6 h-[26rem] w-[26rem] -translate-x-1/2 sm:h-[34rem] sm:w-[34rem]" data-id="element-32" data-mp="1jcvbm1lxbwyp" />
      <div aria-hidden="true" className="pointer-events-none absolute left-1/2 top-10 hidden h-[22rem] w-[22rem] -translate-x-1/2 rounded-full border border-lavender-200/70 lg:block" data-id="element-33" data-mp="1eebldp0arz0j" />

      <div className="relative mx-auto max-w-content px-5 py-14 sm:px-8 sm:py-20 lg:py-24" data-id="element-34" data-mp="1o3bq7p1hdomn">
        <div className="mx-auto max-w-2xl text-center" data-id="element-35" data-mp="223cyhpk2ryc5">
          <BrandSeal className="mx-auto mb-6 hidden h-20 w-20 sm:block" data-id="element-36" data-mp="223w7ggrqzce1" />

          <h2 id="cierre-titulo" className="font-display text-[1.75rem] leading-[1.14] text-plum-900 sm:text-[2.5rem] lg:text-[2.9rem]" data-id="element-37" data-mp="1x5uodvubnd2k">
            Tu negocio puede empezar con una idea.
            <span className="block text-plum-500" data-id="element-38" data-mp="s4xn1b7lh9jg">La estructura empieza con una decisión.</span>
          </h2>
          <p className="mx-auto mt-4 max-w-md text-[1rem] leading-relaxed text-muted sm:mt-5 sm:text-[1.0625rem]" data-id="element-39" data-mp="x5v41kgvbxjd">
            Cuéntanos en qué etapa estás y te ayudamos a identificar el siguiente paso.
          </p>

          <div className="mt-7 flex flex-col items-stretch gap-2.5 sm:mt-8 sm:flex-row sm:items-center sm:justify-center sm:gap-3" data-id="element-40" data-mp="1b3jowsaxr4of">
            <Button size="lg" analyticsId="final_cta_form" onClick={() => scrollToSection(SECTION_IDS.formulario)} data-id="element-41" data-mp="1fvb7ognuo640">
              Quiero saber por dónde empezar
            </Button>
            <ButtonLink size="lg" variant="outline" analyticsId="final_cta_whatsapp" href={WHATSAPP_URL} data-id="element-42" data-mp="1pqcx7dm1fa74">
              Hablar por WhatsApp
            </ButtonLink>
          </div>
        </div>
      </div>
    </section>;
}